<div class="pms-integration">
  <!-- Loading Spinner -->
  <div class="spinner-wrapper" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <div class="element-wrapper">
    <div class="element-box">
      <!-- Existing Integrations List (separate section) -->
      <div *ngIf="systemIntegrations.length > 1" class="mb-3">
        <h6>{{ 'PMSIntegration.ExistingIntegrations' | translate }}</h6>
        <div class="list-group">
          <div *ngFor="let integration of systemIntegrations" class="list-group-item">
            <strong>{{ integration.system }}</strong>
            <button class="btn btn-sm btn-primary ml-2" (click)="selectHotelSystem(integration.system)">
              {{ integration.data.length ? ('PMSIntegration.Edit' | translate) : ('PMSIntegration.Add' | translate) }}
            </button>
          </div>
        </div>
      </div>

      <!-- Row containing both the dropdown (left) and the form (right) -->
      <div class="row">
        <!-- Dropdown Column -->
        <div class="col-md-4">
          <div class="form-group">
            <h6 class="element-header">{{ 'PMSIntegration.SelectHotelIntegrations' | translate }}</h6>
            <ng-select
              [items]="hotelSystems"
              bindLabel="value"
              bindValue="id"
              [searchable]="false"
              [clearable]="false"
              placeholder="{{ 'PMSIntegration.SelectHotelIntegrations' | translate }}"
              [(ngModel)]="dropdownSelected"
              (change)="onDropdownChange($event)"
              appendTo="body"
            >
            </ng-select>
          </div>
        </div>

        <!-- Dynamic Form Column -->
        <div class="col-md-8" *ngIf="selectedHotelSystem">
          <form [formGroup]="dynamicForm" class="mt-3">
            <div class="row">
              <div *ngFor="let field of HOTEL_SYSTEM_FIELDS[selectedHotelSystem]" class="col-md-6 form-group">
                <label>{{ field.label }}</label>
                <ng-container *ngIf="field.type === 'select'; else textInput">
                  <select class="form-control" [formControlName]="field.key">
                    <option *ngFor="let opt of field.options" [value]="opt">{{ opt }}</option>
                  </select>
                </ng-container>
                <ng-template #textInput>
                  <input class="form-control" [formControlName]="field.key" [type]="field.type" />
                </ng-template>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="buttonRows mt-3">
              <button class="btn btn-primary" type="button" (click)="submitData()">
                {{ 'PMSIntegration.SaveIntegration' | translate }}
              </button>
              <button class="btn btn-danger ml-2" type="button" (click)="deleteData()" [disabled]="!hasExistingData()">
                {{ 'PMSIntegration.DeleteIntegration' | translate }}
              </button>
            </div>
          </form>

          <!-- MEWS: Test Connection / Re-sync / Re-import / Enable toggle -->
          <div class="pms-actions mt-3" *ngIf="selectedHotelSystem === 'MEWS'">
            <button
              class="btn btn-outline-primary mr-2"
              type="button"
              (click)="testConnection()"
              [disabled]="testingConnection"
            >
              <span *ngIf="testingConnection" class="spinner-border spinner-border-sm mr-1"></span>
              {{ testingConnection ? 'Testing...' : 'Test Connection' }}
            </button>
            <button class="btn btn-outline-secondary mr-2" type="button" (click)="syncNow()" [disabled]="syncing">
              <span *ngIf="syncing" class="spinner-border spinner-border-sm mr-1"></span>
              {{ syncing ? 'Syncing...' : 'Re-sync now' }}
            </button>
            <!-- <button class="btn btn-outline-secondary mr-2" type="button" (click)="reimportAll()" [disabled]="importing">
              <span *ngIf="importing" class="spinner-border spinner-border-sm mr-1"></span>
              {{ importing ? 'Importing...' : 'Re-import all' }}
            </button> -->
            <mat-slide-toggle [checked]="connectionEnabled" (change)="toggleConnection()" class="ml-2">
              {{ connectionEnabled ? 'Enabled' : 'Disabled' }}
            </mat-slide-toggle>
          </div>

          <!-- MEWS: Sync status panel -->
          <div class="pms-sync-status mt-3 p-3 border rounded" *ngIf="syncStatus && selectedHotelSystem === 'MEWS'">
            <h6 class="mb-2">Sync Status</h6>
            <div class="d-flex align-items-center mb-1">
              <span class="text-muted mr-2">Last sync:</span>
              <span>{{ syncStatus.lastSyncAt ? (syncStatus.lastSyncAt | date: 'dd.MM.yyyy HH:mm') : 'Never' }}</span>
            </div>
            <div class="d-flex align-items-center mb-1">
              <span class="text-muted mr-2">Status:</span>
              <span
                class="badge"
                [ngClass]="syncStatus.lastSyncStatus === 'success' ? 'badge-success' : 'badge-danger'"
              >
                {{ syncStatus.lastSyncStatus || '—' }}
              </span>
            </div>
            <div class="d-flex align-items-center mb-1" *ngIf="syncStatus.lastSyncCounts">
              <span class="text-muted mr-2">Last counts:</span>
              <span>
                {{ syncStatus.lastSyncCounts.upserted }} updated &nbsp;·&nbsp;
                {{ syncStatus.lastSyncCounts.cancelled }} cancelled &nbsp;·&nbsp;
                {{ syncStatus.lastSyncCounts.total }} total
              </span>
            </div>
            <div class="d-flex align-items-center text-danger" *ngIf="syncStatus.lastSyncStatus === 'error'">
              <span class="text-muted mr-2">Error:</span>
              <small>{{ syncStatus.lastSyncError }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template [ngIf]="integrationData && integrationData.length">
    <div class="element-wrapper">
      <h5 class="element-header">{{ 'PMSProductIntegration.pmsProductIntegration' | translate }}</h5>
      <div class="element-box">
        <div (click)="onProductFormSubmit()" class="float-right">
          <button type="button" class="btn btn-primary">{{ 'PMSProductIntegration.AddNewProduct' | translate }}</button>
        </div>
        <div class="product-table mt-4">
          <h6 class="element-header">{{ 'PMSProductIntegration.PmsProductList' | translate }}</h6>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ 'PMSProductIntegration.productTable.SrNo' | translate }}</th>
                  <th>{{ 'PMSProductIntegration.productTable.Type' | translate }}</th>
                  <th>{{ 'PMSProductIntegration.productTable.RatePlanCode' | translate }}</th>
                  <th>{{ 'PMSProductIntegration.productTable.MealName' | translate }}</th>
                  <th>{{ 'PMSProductIntegration.productTable.CreatedAt' | translate }}</th>
                  <th>{{ 'PMSProductIntegration.productTable.Action' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let product of productIntegrationData; let i = index">
                  <td class="nowrap">
                    <span>{{ i + 1 }}</span>
                  </td>
                  <td class="nowrap">
                    <span>{{ getProductTypeLabel(product.type) }}</span>
                  </td>
                  <td class="nowrap">
                    <span>{{ product.codeName || 'NA' }}</span>
                  </td>
                  <td class="nowrap">
                    <span
                      class="p-1 rounded"
                      [style.backgroundColor]="getBackgroundColor(product.mealName)"
                      [style.borderColor]="getBackgroundColor(product.mealName)"
                      >{{ mealLabelMap[product.mealName] || 'NA' }}</span
                    >
                  </td>
                  <td class="nowrap">
                    <span>{{ product.createdAt | date: 'dd/MM/yyyy' }}</span>
                  </td>
                  <td class="nowrap">
                    <span>
                      <button
                        type="button"
                        class="btn btn-light"
                        (click)="editPMSProductData(product)"
                        matTooltip="{{ 'PMSIntegration.Edit' | translate }}"
                      >
                        <i class="fas fa-edit"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger"
                        (click)="deletePMSProductData(product.id)"
                        matTooltip="{{ 'PMSIntegration.DeleteIntegration' | translate }}"
                      >
                        <i class="far fa-trash-alt"></i>
                      </button>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <p class="text-center" *ngIf="!productIntegrationData.length">
              <strong>No Product Data Available </strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
